// Reason: Handles Google OAuth login and passes the ID token to backend for authentication.
// Enhanced: Modern Google-branded button with logo, white background, and Framer Motion animation.

import React from "react";
import { motion } from "framer-motion";

const buttonVariants = {
  hover: { scale: 1.03, boxShadow: "0px 4px 16px 0px rgba(66,133,244,0.10)" },
  tap: { scale: 0.97 }
};

const GoogleLoginButton = ({ onGoogleAuth }) => (
  <motion.button
    className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg py-2 mt-6 font-semibold text-gray-800 shadow-sm hover:bg-gray-50 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-blue-400"
    onClick={onGoogleAuth}
    type="button"
    variants={buttonVariants}
    whileHover="hover"
    whileTap="tap"
  >
    <svg width="22" height="22" viewBox="0 0 48 48" className="inline-block" aria-hidden="true">
      <g>
        <path fill="#4285F4" d="M24 9.5c3.54 0 6.04 1.53 7.43 2.81l5.48-5.48C33.64 3.54 29.24 1.5 24 1.5 14.82 1.5 6.91 7.6 3.69 15.44l6.77 5.26C12.2 15.13 17.62 9.5 24 9.5z"/>
        <path fill="#34A853" d="M46.1 24.55c0-1.64-.15-3.21-.42-4.73H24v9.01h12.41c-.54 2.9-2.18 5.36-4.66 7.01l7.19 5.6c4.2-3.88 6.6-9.6 6.6-16.89z"/>
        <path fill="#FBBC05" d="M10.46 28.69a14.48 14.48 0 010-9.38l-6.77-5.26A23.97 23.97 0 001.5 24c0 3.77.9 7.34 2.49 10.56l6.77-5.26z"/>
        <path fill="#EA4335" d="M24 46.5c6.24 0 11.47-2.07 15.29-5.64l-7.19-5.6c-2.01 1.35-4.59 2.16-8.1 2.16-6.38 0-11.8-5.63-13.54-13.06l-6.77 5.26C6.91 40.4 14.82 46.5 24 46.5z"/>
        <path fill="none" d="M1.5 1.5h45v45h-45z"/>
      </g>
    </svg>
    <span>Sign in with Google</span>
  </motion.button>
);

export default GoogleLoginButton;
